<script>
  // @ts-check
  import Image from "../atoms/Image.svelte";
  import Grid from "../atoms/Grid.svelte";

  /**
   * Primarily used for testing
   * @type {string}
   */
  export let id = undefined;

  /** @type { string } */
  let className = "";
  export { className as class };

  /**
   * The text for quote component.
   * @type {string}
   */
  export let text = undefined;

  /**
   * The caption for quote component.
   * @type {string}
   */
  export let caption = undefined;

  /**
   * Image position - left or right
   * @type {"left" | "right"}
   */
  export let imagePosition = "left";

  /**
   * The optional quote image
   * @type {import('../types/shared.js').Image}
   */
  export let quoteImage = undefined;

  const hasImage = quoteImage?.src && quoteImage?.alt;

  /**
   * Quote style type with "full" as default
   * @type { "inset" | "full" }
   */
  export let variant = "full";

  /**
   * The image variant of quote component
   * @type {"portrait" | "landscape" | "square"}
   */
  export let imageVariant = null;

  const imageAspectRatios = {
    square: "aspect-1/1",
    portrait: "aspect-3/4",
    landscape: "aspect-3/2"
  };

  const imageClass = imagePosition == "right" ? "lg:order-1" : "";
</script>

{#if variant === "full"}
  <Grid
    gridElement="blockquote"
    gridClass="border-y-thin py-7.5 md:py-10 lg:py-15 {className}"
    {id}
  >
    {#if hasImage}
      <Image
        {...quoteImage}
        aspectRatioClasses={imageAspectRatios[imageVariant]}
        containerClass="{imageClass} mb-7.5 md:mb-10 lg:mb-0 col-full-width lg:col-span-6"
      />
    {/if}
    <div class={hasImage ? "col-full-width lg:col-span-6" : "col-full-width"}>
      <p class="heading-md">
        <span class="block leading-[0.9]">“</span>
        <span class="relative -top-4 block lg:-top-6">{text}”</span>
      </p>
      {#if caption}
        <cite class="body-sm mt-1 block not-italic md:mt-3.5 lg:mt-4">
          <span class="mr-2">–</span>{caption}
        </cite>
      {/if}
    </div>
  </Grid>
{:else if variant === "inset"}
  <blockquote class="border-y-thin pb-0 pt-7.5 md:pt-10 lg:pt-15 {className}" {id}>
    {#if hasImage && variant !== "inset"}
      <Image
        {...quoteImage}
        aspectRatioClasses={imageAspectRatios[imageVariant]}
        containerClass="{imageClass} mb-7.5 md:mb-10 lg:mb-0 col-full-width lg:col-span-6"
      />
    {/if}
    <div class={!caption ? "pb-7.5 md:pb-10 lg:pb-15" : ""}>
      <p class="heading-sm">
        <span class="block leading-[0.9]">“</span>
        <span class="relative -top-4 block xl:-top-5">{text}”</span>
      </p>
      {#if caption}
        <cite class="body-sm mt-1 block pb-7.5 not-italic md:mt-3.5 md:pb-10 lg:mt-4 lg:pb-15">
          <span class="mr-2">–</span>{caption}
        </cite>
      {/if}
    </div>
  </blockquote>
{/if}
